import { DataSBFilterValues } from "../../actions/dataTable/DataTableTypes";
import { logOut } from "../layout";
import {
  AddingCriteria,
  AdvancedDeclarationOption,
  BinCreation,
  LocationGrainTrackerValues,
  PrincipalInfoGT,
  QualityCriteriaData,
  StoragesTemplates,
  AllotmentPolicies,
  EditAllotmentPoliciesLocationValues,
  DeleteAllotmentPolicies,
} from "./grainTrackerTypes";

import { createSlice } from "@reduxjs/toolkit";

export interface GrainWiseState {
  isCreatingWithGrainTracker: boolean;

  locationGrainTrackerValues: LocationGrainTrackerValues;
  listOfStoragesTemplates: {
    storagesTemplates: StoragesTemplates | undefined;
    loading: boolean;
    error: string;
  };

  listOfSpecies: {
    speciesTemplates: StoragesTemplates | undefined;
    loading: boolean;
    error: string;
  };
  principalInfoGT: PrincipalInfoGT;
  principalInfoGTCopy: PrincipalInfoGT;

  binCreation: BinCreation;
  binSelectedToModify: any;
  selectIndexLayoutBin: number | undefined;
  errorsUpdateDeleteBin: {
    errorUpdateBin: string;
    errorDeleteBin: string;
  };

  qualityCriteria: {
    data: QualityCriteriaData[];
    total: number;
    limit: number;
    loading: boolean;
    error: string;
  };

  addingCriteria: AddingCriteria;
  selectedCriteria: string | undefined;
  advancedDeclarationOption: AdvancedDeclarationOption;

  advancedDeclarationOptionSelected: {
    allValuesSelected: boolean;
    valuesSelected: DataSBFilterValues[];
  };

  selectedCriteriaToDelete: string[];
  allotmentPolicies: AllotmentPolicies[];

  editBinAllotment: EditAllotmentPoliciesLocationValues;
  editBins: EditAllotmentPoliciesLocationValues;
  deleteAllotmentPolicies: DeleteAllotmentPolicies;

  theBinIsGoodValues: boolean;
}

export const initialState: GrainWiseState = {
  isCreatingWithGrainTracker: true,
  locationGrainTrackerValues: {
    loading: false,
    locationInformation: undefined,
    isEditingBin: false,
    storagesTotal: 0,
    isAddingStorage: false,
    locationStorageCriteriaToAdd: {},
    storagesList: [],
    error: "",
  },
  listOfStoragesTemplates: {
    storagesTemplates: undefined,
    loading: false,
    error: "",
  },

  listOfSpecies: {
    speciesTemplates: undefined,
    loading: false,
    error: "",
  },

  principalInfoGT: {
    type: undefined,
    name: "",
    specie: undefined,
    storage: undefined,
    tonsCapacity: undefined,
    id: undefined,
    currentCharacteristics: [],
    allotmentPolicies: [],
  },

  principalInfoGTCopy: {
    type: undefined,
    name: "",
    specie: undefined,
    storage: undefined,
    tonsCapacity: undefined,
    id: undefined,
    currentCharacteristics: [],
    allotmentPolicies: [],
  },

  binCreation: {
    data: undefined,
    loading: false,
    error: "",
  },
  binSelectedToModify: undefined,

  selectIndexLayoutBin: undefined,
  errorsUpdateDeleteBin: {
    errorUpdateBin: "",
    errorDeleteBin: "",
  },

  qualityCriteria: {
    data: [],
    total: 0,
    limit: 0,
    loading: false,
    error: "",
  },

  addingCriteria: {
    adding: false,
    values: {
      storageInstanceId: "",
      storageQualityCriterionId: "",
      allotmentOperator: "",
      allotmentValue: "",
      allotmentValueArray: [],
    },
  },

  selectedCriteria: undefined,

  advancedDeclarationOption: {
    searchText: "",
    tagsSelected: [],
    tagsInfoResults: "",
    tagsResults: [],
    loading: false,
    error: "",
  },
  advancedDeclarationOptionSelected: {
    allValuesSelected: false,
    valuesSelected: [],
  },

  selectedCriteriaToDelete: [],
  allotmentPolicies: [],

  editBinAllotment: {
    editedDone: false,
    editedError: "",
    editedLoading: false,
  },

  editBins: {
    editedDone: false,
    editedError: "",
    editedLoading: false,
  },

  deleteAllotmentPolicies: {
    deleteDone: false,
    deleteLoading: false,
    deleteError: "",
    deletedLengthOfPolicies: 0,
  },

  theBinIsGoodValues: false,
};

export const GrainWiseSlice = createSlice({
  name: "GrainWiseReducer",
  initialState,
  reducers: {
    setTheBinIsGood(state, action) {
      return {
        ...state,
        theBinIsGoodValues: action.payload,
      };
    },

    resetMessagesDone(state) {
      return {
        ...state,
        editBinAllotment: initialState.editBinAllotment,
        editBins: initialState.editBins,
        deleteAllotmentPolicies: initialState.deleteAllotmentPolicies,
      };
    },

    setDeleteAllotmentDone(state, actions) {
      return {
        ...state,
        deleteAllotmentPolicies: actions.payload,
      };
    },

    setEditBinsDone(state, actions) {
      return {
        ...state,
        editBins: actions.payload,
      };
    },

    setEditBinAllotmentDone(state, actions) {
      return {
        ...state,
        editBinAllotment: actions.payload,
      };
    },

    setAllotmentPolicies(state, action) {
      return {
        ...state,
        allotmentPolicies: action.payload,
      };
    },

    setCriteriaValuesToDelete(state, action) {
      return {
        ...state,
        selectedCriteriaToDelete: action.payload,
      };
    },

    resetAdvancedDeclarationOptionAndDeclarationOptions(state) {
      return {
        ...state,
        advancedDeclarationOption: initialState.advancedDeclarationOption,
        advancedDeclarationOptionSelected:
          initialState.advancedDeclarationOptionSelected,
      };
    },
    setAvancedDeclarationOptionSelected(state, action) {
      return {
        ...state,
        advancedDeclarationOptionSelected: action.payload,
      };
    },
    setAdvancedDeclarationOption(state, action) {
      return {
        ...state,
        advancedDeclarationOption: action.payload,
      };
    },

    selectedCriteria(state, action) {
      return {
        ...state,
        selectedCriteria: action.payload,
      };
    },
    resetCriteriaToBin(state) {
      return {
        ...state,
        addingCriteria: initialState.addingCriteria,
      };
    },
    setCriteriaToBin(state, action) {
      return {
        ...state,
        addingCriteria: action.payload,
      };
    },
    resetQualityCriteriaData(state) {
      return {
        ...state,
        qualityCriteria: initialState.qualityCriteria,
      };
    },
    setQualityCriteriaData(state, action) {
      return {
        ...state,
        qualityCriteria: action.payload,
      };
    },
    setCancelValuestoEditLocation(state) {
      return {
        ...state,
        principalInfoGT: initialState.principalInfoGT,
        principalInfoGTCopy: initialState.principalInfoGTCopy,
      };
    },

    setErrorUpdateDeleteBin(state, action) {
      return {
        ...state,
        errorsUpdateDeleteBin: action.payload,
      };
    },
    selecteBinIndex(state, action) {
      return {
        ...state,
        selectIndexLayoutBin: action.payload,
      };
    },
    setBinToModify(state, action) {
      return {
        ...state,
        binSelectedToModify: action.payload,
      };
    },
    setBinCreationValues(state, action) {
      return {
        ...state,
        binCreation: action.payload,
      };
    },
    setPrincipalInfoGT(state, action) {
      return {
        ...state,
        principalInfoGT: action.payload,
      };
    },
    setPrincipalInfoGTCopy(state, action) {
      return {
        ...state,
        principalInfoGTCopy: action.payload,
      };
    },
    setListOfSpeciesTemplates(state, action) {
      return {
        ...state,
        listOfSpecies: action.payload,
      };
    },

    setListOfStoragesTemplates(state, action) {
      return {
        ...state,
        listOfStoragesTemplates: action.payload,
      };
    },
    setLocationGrainTracker(state, action) {
      return {
        ...state,
        locationGrainTrackerValues: action.payload,
      };
    },
    setIsCreatinWithGraintracker(state, action) {
      return {
        ...state,
        isCreatingWithGrainTracker: action.payload,
      };
    },

    logoutGrainTracker() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  setTheBinIsGood,
  resetMessagesDone,
  setDeleteAllotmentDone,
  setEditBinsDone,
  setEditBinAllotmentDone,
  setAllotmentPolicies,
  setCriteriaValuesToDelete,
  logoutGrainTracker,
  resetAdvancedDeclarationOptionAndDeclarationOptions,
  setAvancedDeclarationOptionSelected,
  setAdvancedDeclarationOption,
  selectedCriteria,
  resetCriteriaToBin,
  setCriteriaToBin,
  resetQualityCriteriaData,
  setQualityCriteriaData,
  setCancelValuestoEditLocation,
  setErrorUpdateDeleteBin,
  selecteBinIndex,
  setPrincipalInfoGTCopy,
  setBinToModify,
  setBinCreationValues,
  setPrincipalInfoGT,
  setListOfSpeciesTemplates,
  setListOfStoragesTemplates,
  setLocationGrainTracker,
  setIsCreatinWithGraintracker,
} = GrainWiseSlice.actions;

export const GrainWise = GrainWiseSlice.reducer;
